export const updateTooltipPosition = (
  labelHeight: number,
  point: Highcharts.TooltipPositionerPointObject,
  chart: Highcharts.Chart,
  isXS: boolean,
  selectorId: string
) => {
  const { chartWidth, plotLeft, plotTop } = chart;
  const containerPadding = 16;
  const tooltipElement = document.querySelector(selectorId);
  const tooltipWidth = tooltipElement?.getBoundingClientRect().width || 310;

  let x = isXS ? (chartWidth - tooltipWidth) / 2 : point.plotX + plotLeft + 10;
  const y = plotTop - labelHeight / 2;

  if (!isXS && x + tooltipWidth + containerPadding > chartWidth) {
    x = point.plotX + plotLeft - tooltipWidth - 10;
  }

  x = Math.max(plotLeft + containerPadding, x);

  return { x, y };
};
